package pl.finn.forms.ezw

import io.kvision.core.*
import io.kvision.form.*
import io.kvision.form.check.CheckBox
import io.kvision.form.check.RadioGroup
import io.kvision.form.select.Select
import io.kvision.form.select.selectOption
import io.kvision.form.text.*
import io.kvision.form.upload.uploadInput
import io.kvision.html.*
import io.kvision.modal.Alert
import io.kvision.modal.Confirm
import io.kvision.panel.FieldsetPanel
import io.kvision.panel.SimplePanel
import io.kvision.panel.hPanel
import io.kvision.state.bind
import io.kvision.table.*
import io.kvision.utils.px
import pl.finn.forms.CommonData
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.common.BlockList
import pl.finn.forms.fk02.DynamicFieldsValidator
import pl.finn.forms.utils.model.Util

class EzwPanel : SimplePanel()  {

  private val dynamicFieldsValidator = DynamicFieldsValidator()

  init {
    bind(Model.formularzStore)
    { state ->
      main {
        margin = 15.px
        id = "peupcontent"
        state.bladZapisu?.let {
          div(it, className = "alert alert-danger") {
            role = "alert"
          }
        }
        when (state.widok) {
          FormularzWidok.EDYCJA, FormularzWidok.NOWY -> {
            if (state.form != null) {
              val ezwComponents = EzwComponents(dynamicFieldsValidator)
              val ezwBlockList = BlockList(dynamicFieldsValidator)
              val ezwBlocks = EzwBlocks(dynamicFieldsValidator, ezwComponents, ezwBlockList)
              lateinit var blokA: FieldsetPanel
              lateinit var blokB: FieldsetPanel
              lateinit var blokTrescZawiadomienia: FieldsetPanel
              lateinit var blokZobowiazanego: Div
              lateinit var blokL: FieldsetPanel
              lateinit var blokL2: FieldsetPanel

              val formPanel = formPanel<EzwForm>(
                type = FormType.HORIZONTAL, horizRatio = FormHorizontalRatio.RATIO_3, className = "mx-2 mx-md-5 mt-3",
                condensed = true
              ) {
                add(createButtonPanel(state, this@formPanel))
                h1(
                  "Elektroniczne zawiadomienie wierzyciela", //tytuł
                  className = "h4 text-center"
                ) {
                  tabindex = -1
                }
                //place for fields [start]

                //bloki
                //rodzajInformacjiZawartejWZawiadomieniu
                //1. A, L, Ł(opcjonalny)
                //2. A, B, I(opcjonalny), J(opcjonalny), K(opcjonalny), L, Ł(opcjonalny)
                //3. A, B, C, L, pozostałe?(opcjonalny)
                // A, B, C, D, E, F, G, H, I, J, K, L, Ł
                // MAX 1 z [E, F, G] wielokrotnie
                // H wielokrotnie
                // H1 wielokrotnie

                add(FieldsetPanel().apply{//Nagłówek
                  add(dynamicFieldsValidator.add(//Text:  kodUrzedu "Kod Organu egzekucyjnego"
                    Select(
                      value = state.form.naglowek.kodUrzedu,
                      label = "Kod Organu egzekucyjnego"
                    ).apply {
                      emptyOption = true
                      onEvent {
                        change = {
                          state.form.naglowek.kodUrzedu = self.value
                        }
                      }
                      for ((key, value) in CommonData.listOfTaxOffices) {
                        selectOption(value = key,label = value)
                        liveSearch = true
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                    POLE_WYMAGANE
                  ))
                })

                add(FieldsetPanel().apply {
                  add(
                    dynamicFieldsValidator.add(
                      RadioGroup(
                        options = EzwData.listOfTypesOfInformationIncludedInNotification,
                        value = state.form.rodzajInformacjiZawartejWZawiadomieniu,
                        label = "Rodzaj informacji zawartej w zawiadomieniu",
                        inline = true
                      ).apply {
                        onEvent {
                          change = {
                            state.form.rodzajInformacjiZawartejWZawiadomieniu = self.value
                            widocznoscBlokow(
                              state.form.rodzajInformacjiZawartejWZawiadomieniu,
                              blokA, blokB, blokTrescZawiadomienia, blokZobowiazanego, blokL, blokL2
                            )
                          }
                        }
                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                        flabel.addCssClass("required-label")
                      },
                      { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                      POLE_WYMAGANE
                    )
                  )
                })

                //A (zawsze)
                blokA = FieldsetPanel("BLOK A – OZNACZENIE WIERZYCIELA/OZNACZENIE ORGANU OBSŁUGUJĄCEGO").apply {
                  add(FieldsetPanel("A1. OZNACZENIE WIERZYCIELA").apply {
                    add(//Text: kodWierzyciela "Kod wierzyciela (ze słownika wierzycieli ustawowych)" http://www.is-szczecin.pl/egzadm/
                      dynamicFieldsValidator.add(
                        Text(
                          value = state.form.blokA.wierzyciel.kodWierzyciela,
                          label = "Kod wierzyciela (ze słownika wierzycieli ustawowych)",
//                                  "<br> <a target=\"_blank\" href=\"http://www.is-szczecin.pl/egzadm/wierzyciele1_prev.php\"><b>Słownik wierzycieli</b></a>",
                        ).apply {
                          onEvent {
                            change = {
                              state.form.blokA.wierzyciel.kodWierzyciela = self.value
                            }
                          }
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                          flabel.addCssClass("required-label")
                        },
                        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("[A-Za-z][A-Za-z0-9]{4,9}")?.toRegex()?.matches(elem) == true) },
                        { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Niewłaściwy kod wierzyciela! Skorzystaj ze słownika wierzycieli ustawowych" else POLE_WYMAGANE) }
                      )
                    )
                    add(p("<br> <a target=\"_blank\" href=\"http://www.is-szczecin.pl/egzadm/wierzyciele1_prev.php\"><b>Słownik wierzycieli</b></a>", rich = true))
                    add(//Text: nazwaWierzyciela "Nazwa wierzyciela"
                      dynamicFieldsValidator.add(
                        Text(
                          value = state.form.blokA.wierzyciel.nazwaWierzyciela,
                          label = "Nazwa wierzyciela"
                        ).apply {
                          onEvent {
                            change = {
                              state.form.blokA.wierzyciel.nazwaWierzyciela = self.value
                            }
                          }
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                          flabel.addCssClass("required-label")
                        },
                        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                        POLE_WYMAGANE
                      )
                    )
                  })
                  add(FieldsetPanel("A2. OZNACZENIE ORGANU OBSŁUGUJĄCEGO").apply {
                    add(dynamicFieldsValidator.add( //Text: NazwaOrganu "Nazwa organu obsługującego"
                      Text(
                        value = state.form.blokA.organObslugujacy.nazwaOrganu,
                        label = "Nazwa organu obsługującego"
                      ).apply {
                        onEvent {
                          change = {
                            state.form.blokA.organObslugujacy.nazwaOrganu = self.value
                          }
                        }
                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                        flabel.addCssClass("required-label")
                      },
                      { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                      POLE_WYMAGANE
                    ))
                    add(ezwComponents.fieldsetPanelAdresPolski(state.form.blokA.organObslugujacy.adres))
                    add(FieldsetPanel("Identyfikator administracyjny organu obsługującego").apply {
                      add(dynamicFieldsValidator.add(//Text: NIP "NIP"
                        Text(
                          value = state.form.blokA.organObslugujacy.admId.nip,
                          label = "NIP"
                        ).apply {
                          onEvent {
                            change = {
                              state.form.blokA.organObslugujacy.admId.nip = self.value
                            }
                          }
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                          flabel.addCssClass("required-label")
                        },//arrayOf("[1-9]((\\d[1-9])|([1-9]\\d))\\d{7}", "Wartość powinna zawierać 10 liczb")
                        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("[1-9]((\\d[1-9])|([1-9]\\d))\\d{7}")?.toRegex()?.matches(elem) == true) },
                        { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Wartość powinna zawierać 10 cyfr" else POLE_WYMAGANE) }
                      ))
                      add(dynamicFieldsValidator.add( //Text: REGON "REGON" (opcjonalny)
                        Text(//VALODATION TNrREGON \d{9}|\d{14}, BEZ 7
                          value = state.form.blokA.organObslugujacy.admId.regon,
                          label = "REGON"
                        ).apply {
                          onEvent {
                            change = {
                              state.form.blokA.organObslugujacy.admId.regon = self.value
                            }
                          }
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                        }, //arrayOf("^(\\d{7}|\\d{9}|\\d{14})$", "Wartość powinna zawierać 7, 9 lub 14 liczb")
                        { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("^(\\d{9}|\\d{14})$")?.toRegex()?.matches(elem) == true) },
                        "Wartość powinna zawierać 9 lub 14 cyfr"
                      ))
                    })
                    add(dynamicFieldsValidator.add( //Text: NrTelefonu
                      Text(//validation TNrTelefonu min 9,  max 30, pattern "\+?[0-9]+([- ][0-9]+)*"
                        value = state.form.blokA.organObslugujacy.nrTelefonu,
                        label = "Numer Telefonu"
                      ).apply {
                        onEvent {
                          change = {
                            state.form.blokA.organObslugujacy.nrTelefonu = self.value
                          }
                        }
                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                        flabel.addCssClass("required-label")
                      },
                      { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("\\+?[0-9]+([- ][0-9]+)*")?.toRegex()?.matches(elem) == true) },
                      { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Niepoprawny numer telefonu" else POLE_WYMAGANE) }
                    ))
                    add(dynamicFieldsValidator.add( //Text: Email
                      Text(//validation TAdresEmail min 3, max 255, pattern "(.)+@(.)+"
                        value = state.form.blokA.organObslugujacy.email,
                        label = "Email"
                      ).apply {
                        onEvent {
                          change = {
                            state.form.blokA.organObslugujacy.email = self.value
                          }
                        }
                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                        flabel.addCssClass("required-label")
                      },
                      { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")?.toRegex()?.matches(elem) == true) },
                      { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Adres e-mail jest niepoprawny" else POLE_WYMAGANE) }
                    ))
                    add(dynamicFieldsValidator.add( //Text: SkrytkaEPuap (opcjonalny)
                      Text( //validation TSkrytkaEPuap "(/)[a-zA-Z0-9\-_]{3,100}(/)[a-zA-Z0-9\-_]{2,100}"
                        value = state.form.blokA.organObslugujacy.skrytkaEPuap,
                        label = "Adres skrzynki ePUAP"
                      ).apply {
                        onEvent {
                          change = {
                            state.form.blokA.organObslugujacy.skrytkaEPuap = self.value
                          }
                        }
                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                      },//arrayOf("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}", "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\"")
                      { elem -> ( ((elem.isNullOrEmpty() || elem.isBlank()) || ("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}")?.toRegex()?.matches(elem) == true) ) },
                      "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\""
                    ))
                    add(ezwBlockList.generateModifiableList(
                      state.form.blokA.organObslugujacy.zmianaRachunkuList,
                      ezwBlocks.blokAZmianaRachunku,
                      :: ZmianaRachunku,
                      "Zmiana rachunku Wierzyciela",
                      { iter -> "Zmiana $iter" }
                    ))
                  })
                }
                //B (zawsze dla 2 i 3)
                blokB = FieldsetPanel("BLOK B - DANE ZOBOWIĄZANEGO/ZOBOWIĄZANYCH").apply { //Zobowiazany
                  var osobaFizyczna = Div().apply {
                    visible = state.form.blokB.rodzajZobowiazanego == "0"
                    add(ezwComponents.fieldsetPanelOsobaFizyczna(state.form.blokB.osobaFizyczna))
                  }
                  var osobaNiefizyczna = Div().apply {
                    visible = state.form.blokB.rodzajZobowiazanego == "1"
                    add(ezwComponents.fieldsetPanelOsobaNiefizyczna(state.form.blokB.osobaNiefizyczna))
                  }
                  var malzonkowie = FieldsetPanel("Małżonkowie").apply {
                    visible = state.form.blokB.rodzajZobowiazanego == "2"
                    add(ezwComponents.fieldsetPanelOsobaFizyczna(state.form.blokB.solidarni.malzonek1))
                    add(ezwComponents.fieldsetPanelOsobaFizyczna(state.form.blokB.solidarni.malzonek2))
                  }
                  add(dynamicFieldsValidator.add(
                    Select( //Select: typ zobowiazanego
                      value = state.form.blokB.rodzajZobowiazanego,
                      label = "Rodzaj zobowiazanego"
                    ).apply {
                      emptyOption = true
                      onEvent {
                        change = {
                          state.form.blokB.rodzajZobowiazanego = self.value
                          when(self.value) {
                            "0" -> {
                              osobaFizyczna.show()
                              osobaNiefizyczna.hide()
                              malzonkowie.hide()
                            }
                            "1" -> {
                              osobaFizyczna.hide()
                              osobaNiefizyczna.show()
                              malzonkowie.hide()
                            }
                            "2" -> {
                              osobaFizyczna.hide()
                              osobaNiefizyczna.hide()
                              malzonkowie.show()
                            }

                          }
                        }
                      }
                      for ((key, value) in EzwData.listOfOptionsOfObligated) {
                        selectOption(value = key.toString(),label = value)
                        liveSearch = true
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                    POLE_WYMAGANE
                  ))

                  add(osobaFizyczna)
                  add(osobaNiefizyczna)
                  add(malzonkowie)

                  add(CheckBox(//Checkbox: zmianaDanych "Zmiana danych zobowiązanego"
                    value = state.form.blokB.zmianaDanych,
                    label = "Zmiana danych zobowiązanego",
                    rich = true
                  ).apply {
                    onEvent {
                      change = {
                        state.form.blokB.zmianaDanych = self.value
                      }
                    }
                  })
                }

                blokTrescZawiadomienia = ezwBlockList.generateModifiableList(
                  state.form.trescZawiadomieniaList,
                  ezwBlocks.blokTrescZawiadomienia,
                  :: TrescZawiadomienia,
                  "Treść Zawiadomienia",
                  { iter -> "Treść zawiadomienia, dla dokumentu $iter." },
                  firstElementObligatory = true
                )

                blokZobowiazanego = ezwBlocks.blokZobowiazanego(
                  state.form.blokIList,
                  state.form.blokJList,
                  state.form.blokKList
                )

                //L (zawsze)
                blokL = FieldsetPanel("BLOK L - DATA I PODPIS WIERZYCIELA").apply {
                  add(ezwComponents.dateField(//Text: dataSporządzenia  "Data sporządzenia"
                    field = state.form.blokL.dataSporządzenia,
                    label = "Data sporządzenia"
                  ))
                  add(FieldsetPanel("Imię i nazwisko osoby upoważnionej do działania w imieniu wierzyciela").apply { //OsobyUpoważnionaDoDziałaniaWImieniuWierzyciela
                    add(dynamicFieldsValidator.add( //Text: imieOsobyUpoważnionaDoDziałaniaWImieniuWierzyciela "Imię"
                      Text(//VALIDATION TImie ( MAX 30)
                        value = state.form.blokL.imieOsobyUpoważnionaDoDziałaniaWImieniuWierzyciela,
                        label = "Imię"
                      ).apply {
                        onEvent {
                          change = {
                            state.form.blokL.imieOsobyUpoważnionaDoDziałaniaWImieniuWierzyciela = self.value
                          }
                        }
                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                        flabel.addCssClass("required-label")
                      },
                      { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                      POLE_WYMAGANE
                    ))
                    add(dynamicFieldsValidator.add( //Text: nazwiskoOsobyUpoważnionaDoDziałaniaWImieniuWierzyciela "Nazwisko"
                      Text(
                        value = state.form.blokL.nazwiskoOsobyUpoważnionaDoDziałaniaWImieniuWierzyciela,
                        label = "Nazwisko"
                      ).apply {
                        onEvent {
                          change = {
                            state.form.blokL.nazwiskoOsobyUpoważnionaDoDziałaniaWImieniuWierzyciela = self.value
                          }
                        }
                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                        flabel.addCssClass("required-label")
                      },
                      { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                      POLE_WYMAGANE
                    ))
                  })

                  add(dynamicFieldsValidator.add( //Text: nrTelefonu "Numer telefonu" //opcjonalne
                    Text(
                      value = state.form.blokL.nrTelefonu,
                      label = "Numer telefonu"
                    ).apply {
                      onEvent {
                        change = {
                          state.form.blokL.nrTelefonu = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                    },
                    { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("\\+?[0-9]+([- ][0-9]+)*")?.toRegex()?.matches(elem) == true) },
                    "Niepoprawny numer telefonu"
                  )) //arrayOf("\\+?[0-9]+([- ][0-9]+)*", "Niepoprawny numer telefonu")

                  add(dynamicFieldsValidator.add( //Text: email "Email" //opcjonalne
                    Text(
                      value = state.form.blokL.email,
                      label = "Email"
                    ).apply {
                      onEvent {
                        change = {
                          state.form.blokL.email = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                    },
                    { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")?.toRegex()?.matches(elem) == true) },
                    "Adres e-mail jest niepoprawny"
                  ))//"^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$", "Adres e-mail jest niepoprawny"
                }

                //Ł (opcjonalny) //aka L2
                blokL2 = FieldsetPanel("BLOK Ł - ZAŁĄCZNIKI").apply {
                  var blokL2zawartoscOpcjonalna = Div().apply {
                    visible = state.form.blokL2.posiadaBlok
                    div("Załączniki do pisma")
                    if (!state.form.blokL2.zalaczniki.isNullOrEmpty()) {
                      table(
                        listOf("Nazwa pliku", "Opis załącznika", ""),
                        setOf(TableType.HOVER, TableType.STRIPED, TableType.BORDERED, TableType.SMALL),
                        "Lista załączników do pisma",
                        responsiveType = ResponsiveType.RESPONSIVE
                      ) {
                        state.form.blokL2.zalaczniki.forEach { zalacznik ->
                          row {
                            cell {
                              verticalAlign = VerticalAlign.MIDDLE
                              b(zalacznik.nazwa)
                            }
                            cell {
                              verticalAlign = VerticalAlign.MIDDLE
                              zalacznik.opis?.let {
                                div(it)
                              }
                            }
                            cell {
                              align = Align.CENTER
                              width = 150.px
                              button("Usuń załącznik", "fas fa-trash", ButtonStyle.DANGER) {
                                size = ButtonSize.SMALL
                                onClick {
                                  Model.usunZalacznik(
                                    zalacznik.nazwa,
                                    state.form
                                  )
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    hPanel(spacing = 10, wrap = FlexWrap.WRAP, className = "wrap-panel") {
                      val zalacznik = uploadInput("/") {
                        explorerTheme = true
                        showUpload = false
                        showCancel = false
                        showPreview = false
                        dropZoneEnabled = false
                        allowedFileExtensions = Util.rozszerzeniaZalacznikow
                      }
                      val opisZalacznika = textInput {
                        width = 300.px
                        placeholder = "Wprowadź opis załącznika"
                      }
                      button("Dodaj", "fas fa-upload").onClick {
                        if(zalacznik.value == null || opisZalacznika.value == null) {
                          Alert.show(
                            "Nie można dodać załącznika",
                              "Sprawdź czy pola wypełnione są poprawnie.<br/>" +
                              "Nazwa załącznika może zawierać wyłącznie litery, cyfry, \"_\", \".\" .<br/>" +
                              "Opis załącznika musi być wypełniony.",
                            rich = true
                          )
                        } else {
                          Model.dodajZalacznik(
                            zalacznik,
                            opisZalacznika.value,
                            state.form
                          )
                        }
                      }
                    }
                    tag(
                      TAG.SMALL,
                      "Dozwolone rozszerzenia plików to: ${
                        Util.rozszerzeniaZalacznikow.map { ".$it" }
                          .joinToString()
                      }."
                    )
                  }
                  add(ezwComponents.checkBoxPosiadaBlok(blok = state.form.blokL2, blokDiv = blokL2zawartoscOpcjonalna, "Dodaj załączniki"))
                  add(blokL2zawartoscOpcjonalna)
                }

                widocznoscBlokow(
                  state.form.rodzajInformacjiZawartejWZawiadomieniu,
                  blokA, blokB, blokTrescZawiadomienia, blokZobowiazanego, blokL, blokL2
                )
                add(blokA)
                add(blokB)
                add(blokTrescZawiadomienia)
                add(blokZobowiazanego)
                add(blokL)
                add(blokL2)

                //place for fields [end]
              }
            }
          }
          else -> {}
        }
      }

    }

  }

  private fun widocznoscBlokow(
    rodzajInformacjiZawartejWZawiadomieniu: String?,
    blokA: FieldsetPanel,
    blokB: FieldsetPanel,
    blokTrescZawiadomienia: FieldsetPanel,
    blokZobowiazanego: Div,
    blokL: FieldsetPanel,
    blokL2: FieldsetPanel
  ) {
    if (rodzajInformacjiZawartejWZawiadomieniu == "0") { //"1. Zawiadomienie dotyczące wierzyciela"
      blokA.show()
      blokB.hide()
      blokTrescZawiadomienia.hide()
      blokZobowiazanego.hide()
      blokL.show()
      blokL2.show()
    }

    if (rodzajInformacjiZawartejWZawiadomieniu == "1") { //"2. Zawiadomienie dotyczące zobowiązanego"
      blokA.show()
      blokB.show()
      blokTrescZawiadomienia.hide()
      blokZobowiazanego.show()
      blokL.show()
      blokL2.show()
    }
    if (rodzajInformacjiZawartejWZawiadomieniu == "2") { //"3. Zawiadomienie dotyczące tytułu/zarządzenia zabezpieczenia"
      blokA.show()
      blokB.show()
      blokTrescZawiadomienia.show()
      blokZobowiazanego.hide()
      blokL.show()
      blokL2.show()
    }
    if (rodzajInformacjiZawartejWZawiadomieniu == null) {
      blokA.hide() //moglby byc widoczne zawsze
      blokB.hide()
      blokTrescZawiadomienia.hide()
      blokZobowiazanego.hide()
      blokL.hide() //moglby byc widoczne zawsze
      blokL2.hide() //moglby byc widoczne zawsze
    }
  }

  private fun createButtonPanel(state: Formularz, reference: FormPanel<EzwForm>): Div {
    return (
      Div(className = "form-group my-3") {
        div(className = "row") {
          div(className = "col-lg-6") {
            div(className = "row") {
              div(className = "col-sm-6 py-2") {
                button(
                  "Zapisz dokument",
                  "far fa-save fa-3x d-block",
                  ButtonStyle.SUCCESS, className = "w-100"
                ).onClick {
                  val referenceData = state.form /*getReferenceData(reference, state)*/
                  val validateResult =
                    if (!(/*reference.validate() &&*/ dynamicFieldsValidator.validate()))
                      "Dokument zawiera niepoprawne dane." else null
                  referenceData?.let { it1 -> Model.zapisz(it1, validateResult) }
                }
              }
              div(className = "col-sm-6 py-2") {
                button("Sprawdź dokument", "fas fa-tasks fa-3x d-block", className = "w-100").onClick {
//                  val isValidatedStatic = reference.validate()
                  val isValidatedDynamic = dynamicFieldsValidator.validate()
                  if (/*isValidatedStatic &&*/ isValidatedDynamic) {
                    Alert.show(
                      "Sprawdzenie dokumentu",
                      "Dokument jest poprawny.<br/>Wszystkie pola wypełnione są prawidłowo.",
                      rich = true
                    )
                  } else {
                    Alert.show(
                      "Sprawdzenie dokumentu",
                      "Dokument zawiera niepoprawne dane.<br/>Należy poprawić pola oznaczone na czerwono.",
                      rich = true
                    )
                  }
                  Model.sprawdz()
                }
              }
            }
          }
          div(className = "col-lg-6") {
            div(className = "row") {
              div(className = "col-sm-6 py-2") {
                button("Podgląd dokumentu", "fas fa-eye fa-3x d-block", className = "w-100").onClick {
                  val referenceData = state.form /*getReferenceData(reference, state)*/
                  referenceData?.let { it1 -> Model.podglad(it1, this) }
                }
              }
              div(className = "col-sm-6 py-2") {
                button(
                  "Anuluj",
                  "fas fa-times fa-3x d-block",
                  ButtonStyle.SECONDARY, className = "w-100"
                ).onClick {
                  Confirm.show(
                    "Potwierdzenie",
                    "Czy anulować edycję formularza i powrócić do poprzedniej strony?",
                    yesTitle = "Tak",
                    noTitle = "Nie"
                  ) {
                    Model.anuluj()
                  }
                }
              }
            }
          }
        }
      }
    )
  }

}
